import React, { useState, useEffect, Fragment } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, MenuItem

} from '@material-ui/core';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import tokenService from '../../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../../utils/newLoader';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    },
    paper: {
        height: 300,
        width: '100%',
        overflow: 'auto',
        border: '1px solid #ddd',
        marginTop: theme.spacing(1)
    }

}));

export default function BalanceSheetReportConfigurationSetup({ groupID, factoryID }) {

    const alert = useAlert();
    const classes = useStyles();
    const [BalanceSheetDetails, setBalanceSheetDetails] = useState({
        groupID: groupID,
        factoryID: factoryID,
        parentSectionID: '0',
        sectionName: '0',
        accountFilterType: '0',
        accountFilterText: ''
    });
    const [BalanceSheetSctionList, setBalanceSheetSctionList] = useState();
    const [ParentSectionNameList, setParentSectionNameList] = useState();
    const [checked, setChecked] = useState([]);
    const [LeftNewArray, setLeftNewArray] = useState([]);
    const [RightNewArray, setRightNewArray] = useState([]);
    const [RightNewArrayAlreadyStoredAccounts, setRightNewArrayAlreadyStoredAccounts] = useState([])
    const [RemovedLedgerAccountList, setRemovedLedgerAccountList] = useState([]);
    const [isSectionSelected, setIsSectionSelected] = useState(false);

    const leftChecked = intersection(checked, LeftNewArray);
    const rightChecked = intersection(checked, RightNewArray);

    function not(a, b) {
        return a.filter((value) => b.map(obj => obj.ledgerAccountID).indexOf(value.ledgerAccountID) === -1);
    }

    function intersection(a, b) {
        return a.filter((value) => b.map(obj => obj.ledgerAccountID).indexOf(value.ledgerAccountID) !== -1);
    }

    const handleToggle = (value) => () => {
        const currentIndex = checked.map(obj => obj.ledgerAccountID).indexOf(value.ledgerAccountID);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleAllRight = () => {
        setRightNewArray(RightNewArray.concat(LeftNewArray));
        setLeftNewArray([]);
    };

    const handleCheckedRight = () => {
        setRemovedLedgerAccountList(not(RemovedLedgerAccountList, leftChecked))
        setRightNewArray(RightNewArray.concat(leftChecked));
        setLeftNewArray(not(LeftNewArray, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setRemovedLedgerAccountList(RemovedLedgerAccountList.concat(rightChecked))
        setLeftNewArray(LeftNewArray.concat(rightChecked));
        setRightNewArray(not(RightNewArray, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleAllLeft = () => {
        setLeftNewArray(LeftNewArray.concat(RightNewArray));
        setRightNewArray([]);
    };

    const customList = (items) => (
        items && items.length > 0 ? (
            <Paper className={classes.paper}>
                <List dense component="div" role="list">
                    {items.map((value) => {
                        const labelId = `transfer-list-item-${value.ledgerAccountID}-label`;

                        return (
                            <ListItem key={value.ledgerAccountID} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.map(obj => obj.ledgerAccountID).indexOf(value.ledgerAccountID) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.ledgerAccountName} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Paper>
        ) : null
    );

    useEffect(() => {
        if (groupID && factoryID) {
            trackPromise(GetParentSectionDetails());
        }
    }, [groupID, factoryID]);

    useEffect(() => {
        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            groupID: groupID,
            factoryID: factoryID
        })
    }, [groupID, factoryID])

    async function GetParentSectionDetails() {
        const response = await services.GetBalanceSheetParentSectionDetails(groupID, factoryID);
        if (response !== null && response.length > 0) {
            setParentSectionNameList(response);
        }
    }

   async function GetBalanceSheetSectionDetails(parentSectionID) {
    if (!parentSectionID || parentSectionID === "0") {
        setBalanceSheetSctionList([]);
        return;
    }

    const response = await services.GetBalanceSheetSectionDetails(groupID, factoryID, parseInt(parentSectionID));

    if (response !== null && response.length > 0) {
        setBalanceSheetSctionList(response);
    } else {
        alert.error("Please configure section names");
        setBalanceSheetSctionList([]);
    }
}

    async function LoadSetupCofigurations(e) {
        const value = e.target.value;
        setIsSectionSelected(value !== "0");

        if (value === "0") {
            ClearAllArrays();
            return;
        }

        const balanceSheetCongiDetails = await GetBalanceSheetSetupConfigurationDetails(value);
        const chartOfAccountList = await GetAllChartOfAccountDetails();

        if (balanceSheetCongiDetails.data.ledgerAccountList.length === 0) {
            setRightNewArray([]);
            setRightNewArrayAlreadyStoredAccounts([]);
        } else {
            setRightNewArray(balanceSheetCongiDetails.data.ledgerAccountList);
            setRightNewArrayAlreadyStoredAccounts(balanceSheetCongiDetails.data.ledgerAccountList);
        }

        if (chartOfAccountList.length > 0) {
            await SetAndFilterMainLedgerAccountListArrays(chartOfAccountList, balanceSheetCongiDetails.data.ledgerAccountList);
        } else {
            setLeftNewArray([]);
        }
    }

    async function SetAndFilterMainLedgerAccountListArrays(chartsOfAccountList, linkedAccountList) {
        const filteredAccountList = not(chartsOfAccountList, linkedAccountList);
        setLeftNewArray(filteredAccountList);
        return filteredAccountList;
    }

    async function SearchLedgerAccountList() {
        if (BalanceSheetDetails.sectionName === "0") {
            alert.error("Please select a section first");
            return;
        }

        const result = await GetAllChartOfAccountDetails();

        if (result.length === 0) {
            setLeftNewArray([]);
            alert.error("No ledger accounts found with the current filters");
            return;
        }

        if (RightNewArray.length === 0) {
            setLeftNewArray(result);
        } else {
            await SetAndFilterMainLedgerAccountListArrays(result, RightNewArray);
        }
    }

    async function GetBalanceSheetSetupConfigurationDetails(balanceSheetSectionID) {
        const result = await services.GetBalanceSheetSectionSetupConfigurationDetails(
            parseInt(groupID.toString()),
            parseInt(factoryID.toString()),
            parseInt(balanceSheetSectionID.toString())
        );
        return result;
    }

    async function GetAllChartOfAccountDetails() {
        let requestModel = {
            accountFilterText: BalanceSheetDetails.accountFilterText,
            accountFilterType: parseInt(BalanceSheetDetails.accountFilterType.toString()),
            factoryID: parseInt(factoryID.toString()),
            groupID: parseInt(groupID.toString())
        }

        const response = await services.GetAllLedgerAccountDetailsByFilters(requestModel);
        return response;
    }

    async function SaveBalanceSheetSetupDetails() {
        let requestModel = {
            groupID: parseInt(groupID),
            factoryID: parseInt(factoryID),
            balanceSheetSectionID: parseInt(BalanceSheetDetails.sectionName),
            parentSectionID: parseInt(BalanceSheetDetails.parentSectionID),
            createdBy: parseInt(tokenService.getUserIDFromToken()),
            linkedAccountList: not(RightNewArray, RightNewArrayAlreadyStoredAccounts),
            removedLinkedAccountList: RemovedLedgerAccountList
        }

        const response = await services.SaveBalanceSheetSetupDetails(requestModel)

        if (response.statusCode == "Success") {
            alert.success(response.message);
            ClearAllArrays();
        } else {
            alert.error(response.message);
        }
    }

    function ClearAllArrays() {
        setChecked([]);
        setLeftNewArray([]);
        setRightNewArray([]);
        setRightNewArrayAlreadyStoredAccounts([]);
        setRemovedLedgerAccountList([]);
        setIsSectionSelected(false);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            [e.target.name]: value
        });
    }

    function handleChangeAccountType(e) {
        const target = e.target;
        const value = target.value;
        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            [e.target.name]: value,
            accountFilterText: ""
        });
    }

    return (
        <Fragment>
            <Formik
                initialValues={{
                    parentSectionID: BalanceSheetDetails.parentSectionID,
                    sectionName: BalanceSheetDetails.sectionName,
                }}
                validationSchema={
                    Yup.object().shape({
                        sectionName: Yup.number().required('Section Name is required').min("1", 'Section Name is required')
                    })
                }
                onSubmit={() => trackPromise(SaveBalanceSheetSetupDetails())}
                enableReinitialize
            >
                {({
                    errors,
                    handleBlur,
                    handleSubmit,
                    touched
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={0}>
                            <Grid container spacing={3}>
                                <Grid item md={4} xs={12}>
                                    <InputLabel shrink id="parentSectionID">
                                        Parent Section Name *
                                    </InputLabel>
                                   <TextField select
                                        error={Boolean(touched.parentSectionID && errors.parentSectionID)}
                                        fullWidth
                                        helperText={touched.parentSectionID && errors.parentSectionID}
                                        size='small'
                                        name="parentSectionID"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            handleChange(e);
                                            trackPromise(GetBalanceSheetSectionDetails(e.target.value));
                                            setBalanceSheetDetails({
                                                ...BalanceSheetDetails,
                                                parentSectionID: e.target.value,
                                                sectionName: '0'
                                            });
                                            ClearAllArrays();
                                        }}
                                        value={BalanceSheetDetails.parentSectionID}
                                        variant="outlined"
                                        id="parentSectionID"
                                    >
                                        <MenuItem value="0">--Select Parent Section Name--</MenuItem>
                                        {generateDropDownMenu(ParentSectionNameList)}
                                </TextField>
                                 </Grid>
                                    <Grid item md={4} xs={12}>
                                    <InputLabel shrink id="sectionName">
                                        Section Name *
                                    </InputLabel>
                                    <TextField select
                                        error={Boolean(touched.sectionName && errors.sectionName)}
                                        fullWidth
                                        helperText={touched.sectionName && errors.sectionName}
                                        size='small'
                                        name="sectionName"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            handleChange(e);
                                            trackPromise(LoadSetupCofigurations(e));
                                        }}
                                        value={BalanceSheetDetails.sectionName}
                                        variant="outlined"
                                        id="sectionName"
                                    >
                                        <MenuItem value="0">--Select Section Name--</MenuItem>
                                        {generateDropDownMenu(BalanceSheetSctionList)}
                                   </TextField>
                                </Grid>
                            </Grid>

                            <br />

                            {isSectionSelected && (
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={3}>
                                            <Grid item md={6} xs={12}>
                                                <Grid container spacing={1}>
                                                    <Grid item md={5} xs={12}>
                                                        <TextField select
                                                            fullWidth
                                                            name="accountFilterType"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChangeAccountType(e);
                                                            }}
                                                            size='small'
                                                            value={BalanceSheetDetails.accountFilterType}
                                                            variant="outlined"
                                                            id="accountFilterType"
                                                        >
                                                            <MenuItem value="0">All Accounts</MenuItem>
                                                            <MenuItem value="4">Search By Account Type</MenuItem>
                                                            <MenuItem value="1">Search By Parent Header</MenuItem>
                                                            <MenuItem value="2">Search By Child Header</MenuItem>
                                                            <MenuItem value="3">Search By Ledger Header</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    {BalanceSheetDetails.accountFilterType !== "0" && (
                                                        <Grid item md={5} xs={12}>
                                                            <TextField
                                                                variant="outlined"
                                                                fullWidth
                                                                name="accountFilterText"
                                                                id="accountFilterText"
                                                                label="Filtering Text"
                                                                size="small"
                                                                value={BalanceSheetDetails.accountFilterText}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={BalanceSheetDetails.accountFilterType === "0"}
                                                            />
                                                        </Grid>
                                                    )}
                                                    <Grid item md={1} xs={12}>
                                                        <Tooltip title="Filter Account">
                                                            <IconButton
                                                                aria-label="filter"
                                                                onClick={() => trackPromise(SearchLedgerAccountList())}
                                                            >
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <br />

                                        <Grid container spacing={3}>
                                            <Grid item md={5} xs={12}>
                                                <Typography variant='h5'>Chart Of Account</Typography> <br />
                                                {customList(LeftNewArray)}
                                            </Grid>
                                            <Grid item md={2} xs={12}>
                                                <Grid container direction="column" alignItems="center" style={{ marginTop: "30%" }}>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.button}
                                                        onClick={handleCheckedRight}
                                                        disabled={leftChecked.length === 0}
                                                        aria-label="move selected right"
                                                    >
                                                        &gt;
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.button}
                                                        onClick={handleCheckedLeft}
                                                        disabled={rightChecked.length === 0}
                                                        aria-label="move selected left"
                                                    >
                                                        &lt;
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid item md={5} xs={12}>
                                                <Typography variant='h5'>Linked Accounts</Typography> <br />
                                                {customList(RightNewArray)}
                                            </Grid>
                                        </Grid>

                                        <Box display="flex" flexDirection="row-reverse" p={2}>
                                            <Button
                                                color="primary"
                                                type="submit"
                                                variant="contained"
                                            >
                                                Save
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}
                        </Box>
                    </form>
                )}
            </Formik>
        </Fragment>
    );
}